/* ============================================================
   NEAT para Shopify — Interacciones del tema
   Barra de anuncios · header · menú móvil · revelado al scroll
   selector de packs · página de producto · calculadora
   ============================================================ */
(function () {
  "use strict";

  var N = window.NEAT || {};

  function clp(centavos) {
    var valor = Math.round((centavos || 0) / 100);
    try { return "$" + valor.toLocaleString("es-CL"); } catch (e) { return "$" + valor; }
  }

  /* =================== Barra de anuncios =================== */
  function iniciarAnuncios() {
    var barra = document.querySelector(".barra-anuncios");
    if (!barra) return;
    var crudo = (barra.dataset.anuncios || "").trim();
    if (!crudo) return;
    var mensajes = crudo.split(/\r?\n/).map(function (m) { return m.trim(); }).filter(Boolean);
    if (!mensajes.length) return;

    var span = document.createElement("span");
    span.textContent = mensajes[0];
    barra.appendChild(span);
    if (mensajes.length === 1) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var i = 0;
    setInterval(function () {
      i = (i + 1) % mensajes.length;
      var nuevo = span.cloneNode(false);
      nuevo.textContent = mensajes[i];
      barra.replaceChild(nuevo, barra.lastChild);
    }, 3800);
  }

  /* =================== Header =================== */
  function iniciarHeader() {
    var header = document.querySelector(".header");
    if (!header) return;
    var alScroll = function () { header.classList.toggle("con-scroll", window.scrollY > 8); };
    alScroll();
    window.addEventListener("scroll", alScroll, { passive: true });
  }

  /* =================== Menú móvil =================== */
  function iniciarMenuMovil() {
    var botonAbrir = document.querySelector(".boton-menu");
    var datos = document.querySelector("[data-menu-movil]");
    if (!botonAbrir || !datos) return;

    var config;
    try { config = JSON.parse(datos.textContent); } catch (e) { return; }

    var enlaces = (config.enlaces || []).map(function (e) {
      return '<a href="' + e.url + '">' + e.titulo + "</a>";
    }).join("");

    var cta = config.cta && config.cta.titulo
      ? '<a class="btn btn--cta btn--bloque" href="' + (config.cta.url || "/") + '">' + config.cta.titulo + "</a>"
      : "";

    var div = document.createElement("div");
    div.innerHTML =
      '<div class="menu-movil" id="menu-movil" role="dialog" aria-modal="true" aria-label="Menú">' +
      '  <div class="menu-movil__fondo" data-cerrar-menu></div>' +
      '  <nav class="menu-movil__panel" aria-label="Navegación móvil">' +
      '    <button class="menu-movil__cerrar" data-cerrar-menu aria-label="Cerrar menú">✕</button>' +
      '    <div class="menu-movil__nav">' + enlaces + "</div>" +
      '    <div class="menu-movil__pie">' + cta + "</div>" +
      "  </nav>" +
      "</div>";
    document.body.appendChild(div.firstElementChild);

    var menu = document.getElementById("menu-movil");
    botonAbrir.addEventListener("click", function () {
      menu.classList.add("abierto");
      document.body.style.overflow = "hidden";
    });
    function cerrarMenu() {
      menu.classList.remove("abierto");
      document.body.style.overflow = "";
    }
    menu.querySelectorAll("[data-cerrar-menu]").forEach(function (el) { el.addEventListener("click", cerrarMenu); });
    menu.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", cerrarMenu); });
  }

  /* =================== Revelado al hacer scroll =================== */
  function iniciarRevelado() {
    var elementos = document.querySelectorAll(".revelar");
    if (!elementos.length) return;
    if (!("IntersectionObserver" in window)) {
      elementos.forEach(function (el) { el.classList.add("visible"); });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (ent) {
        if (ent.isIntersecting) {
          ent.target.classList.add("visible");
          obs.unobserve(ent.target);
        }
      });
    }, { threshold: 0.15 });
    elementos.forEach(function (el) { obs.observe(el); });
  }

  /* =================== Barras de "¿Dónde se va tu dinero?" =================== */
  function iniciarBarras() {
    var barras = document.querySelectorAll(".barra-costo__relleno");
    if (!barras.length) return;
    if (!("IntersectionObserver" in window)) {
      barras.forEach(function (b) { b.style.width = b.dataset.ancho + "%"; });
      return;
    }
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (ent) {
        if (ent.isIntersecting) {
          ent.target.style.width = ent.target.dataset.ancho + "%";
          obs.unobserve(ent.target);
        }
      });
    }, { threshold: 0.3 });
    barras.forEach(function (b) { obs.observe(b); });
  }

  /* =================== Selector de producto en la sección de packs =================== */
  function iniciarSelectorPacks() {
    var selector = document.getElementById("packs-selector");
    if (!selector) return;
    var botones = selector.querySelectorAll("[data-panel]");
    botones.forEach(function (btn) {
      btn.addEventListener("click", function () {
        botones.forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
        btn.setAttribute("aria-pressed", "true");
        document.querySelectorAll("[data-panel-packs]").forEach(function (p) {
          p.hidden = p.id !== btn.dataset.panel;
        });
      });
    });
  }

  /* =================== Página de producto =================== */
  function iniciarProducto() {
    var compra = document.getElementById("compra");
    if (!compra) return;

    /* Galería */
    var principal = document.getElementById("imagen-principal");
    document.querySelectorAll(".galeria__miniaturas button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (principal) principal.src = btn.dataset.imagen;
        document.querySelectorAll(".galeria__miniaturas button").forEach(function (b) {
          b.setAttribute("aria-pressed", b === btn ? "true" : "false");
        });
      });
    });

    /* Selección de variante */
    var input = compra.querySelector("[data-variante-input]");
    var precio = document.getElementById("precio-dinamico");
    var barraPrecio = document.getElementById("barra-precio");
    var infoEnvio = document.getElementById("info-envio-precio");
    var boton = document.getElementById("btn-agregar");
    var opciones = compra.querySelectorAll(".opcion-pack");

    function actualizar(op) {
      var id = op.dataset.variante;
      var valor = Number(op.dataset.precio || 0);
      var disponible = op.dataset.disponible !== "false";

      if (input) input.value = id;
      if (precio) {
        precio.classList.remove("cambiando");
        void precio.offsetWidth;
        precio.classList.add("cambiando");
        precio.textContent = clp(valor);
      }
      if (barraPrecio) barraPrecio.textContent = clp(valor);
      if (boton) {
        boton.disabled = !disponible;
        boton.textContent = disponible ? "Agregar al carrito" : "Agotado";
      }
      if (infoEnvio) {
        infoEnvio.textContent = N.envioGratisDesde && valor >= N.envioGratisDesde
          ? "Incluye envío gratis."
          : "Despacho desde " + clp(N.costoEnvio) + ", o gratis sobre " + clp(N.envioGratisDesde) + ".";
      }
    }

    opciones.forEach(function (op) {
      op.addEventListener("click", function () {
        opciones.forEach(function (o) { o.classList.toggle("opcion-pack--activa", o === op); });
        var radio = op.querySelector("input");
        if (radio) radio.checked = true;
        actualizar(op);
      });
    });

    var activa = compra.querySelector(".opcion-pack--activa");
    if (activa) actualizar(activa);
    else if (infoEnvio) {
      infoEnvio.textContent = "Despacho desde " + clp(N.costoEnvio) + ", o gratis sobre " + clp(N.envioGratisDesde) + ".";
    }

    /* Barra inferior en móvil */
    var barra = document.getElementById("barra-compra");
    if (barra) {
      var btnBarra = barra.querySelector("[data-agregar-actual]");
      if (btnBarra) {
        btnBarra.addEventListener("click", function () {
          if (input && window.NEAT_CARRITO) window.NEAT_CARRITO.agregar(input.value, 1);
        });
      }
    }
  }

  /* =================== Calculadora de ahorro =================== */
  function iniciarCalculadora() {
    var raiz = document.getElementById("calculadora-ahorro");
    var datos = document.querySelector("[data-calculadora-datos]");
    if (!raiz || !datos) return;

    var config;
    try { config = JSON.parse(datos.textContent); } catch (e) { return; }
    var productos = (config.productos || []).filter(function (p) { return p && p.variantes && p.variantes.length; });
    if (!productos.length) { raiz.style.display = "none"; return; }

    var caps = Number(raiz.dataset.capsulas || 35);
    var iProducto = 0;
    var iVariante = 0;

    function bolsasDe(titulo) {
      var m = String(titulo).match(/\d+/);
      return m ? Number(m[0]) : 1;
    }

    function pintarPacks() {
      var cont = document.getElementById("calc-packs");
      var p = productos[iProducto];
      cont.innerHTML = p.variantes.map(function (v, i) {
        var b = bolsasDe(v.titulo);
        return '<button type="button" data-calc-variante="' + i + '" aria-pressed="' + (i === iVariante ? "true" : "false") + '">' +
          (b === 1 ? "1 bolsa" : b + " bolsas") + "</button>";
      }).join("");
      cont.querySelectorAll("[data-calc-variante]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          iVariante = Number(btn.dataset.calcVariante);
          pintarPacks();
          calcular();
        });
      });
    }

    function tarjeta(cifra, nota, color) {
      return '<div class="dato-clave">' +
        '<span class="dato-clave__cifra dato-clave__cifra--' + color + '">' + cifra + "</span>" +
        '<span class="dato-clave__nota">' + nota + "</span></div>";
    }

    function calcular() {
      var p = productos[iProducto];
      var v = p.variantes[iVariante] || p.variantes[0];
      var bolsas = bolsasDe(v.titulo);
      var referencia = p.variantes[0].precio * bolsas;
      var porBolsa = Math.round(v.precio / bolsas);
      var porLavado = Math.round(v.precio / (bolsas * caps));
      var ahorro = Math.max(0, referencia - v.precio);

      var res = document.getElementById("calc-resultados");
      res.innerHTML =
        tarjeta(clp(v.precio), (bolsas === 1 ? "1 bolsa" : bolsas + " bolsas") + " — " + v.titulo, "azul") +
        tarjeta(clp(porBolsa), "por bolsa de " + caps + " cápsulas", "azul") +
        tarjeta("desde " + clp(porLavado), "por lavado, según dosificación", "magenta") +
        tarjeta(clp(ahorro), "de ahorro frente a comprar bolsas sueltas", "verde") +
        tarjeta(bolsas * caps, "lavados por pack*", "magenta") +
        tarjeta(
          N.envioGratisDesde && v.precio >= N.envioGratisDesde ? "Gratis" : clp(N.costoEnvio),
          N.envioGratisDesde && v.precio >= N.envioGratisDesde ? "de despacho en este pack" : "de despacho referencial",
          "verde"
        );
    }

    raiz.querySelectorAll("[data-calc-producto]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        raiz.querySelectorAll("[data-calc-producto]").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
        btn.setAttribute("aria-pressed", "true");
        iProducto = Math.min(Number(btn.dataset.calcProducto), productos.length - 1);
        iVariante = 0;
        pintarPacks();
        calcular();
      });
    });

    pintarPacks();
    calcular();
  }

  /* =================== Simulador de suscripción =================== */
  function iniciarSimulador() {
    var raiz = document.getElementById("simulador-suscripcion");
    var datos = document.querySelector("[data-simulador-datos]");
    if (!raiz || !datos) return;

    var config;
    try { config = JSON.parse(datos.textContent); } catch (e) { raiz.style.display = "none"; return; }
    var productos = (config.productos || []).filter(function (p) { return p && p.variantes && p.variantes.length; });
    if (!productos.length) { raiz.style.display = "none"; return; }

    var caps = Number(raiz.dataset.capsulas || 35);
    var dPrimera = Number(raiz.dataset.descuentoPrimera || 15);
    var dPermanente = Number(raiz.dataset.descuentoPermanente || 10);
    var frecuencias = (raiz.dataset.frecuencias || "30,45,60,90")
      .split(",").map(function (f) { return parseInt(f, 10); }).filter(Boolean);
    var frecDefecto = parseInt(raiz.dataset.frecuenciaDefecto, 10) || frecuencias[0];

    function bolsasDe(titulo) {
      var m = String(titulo).match(/\d+/);
      return m ? Number(m[0]) : 1;
    }

    var opcionesProducto = productos.map(function (p, i) {
      return '<option value="' + i + '">' + p.titulo + "</option>";
    }).join("");

    var opcionesFrecuencia = frecuencias.map(function (f) {
      return '<option value="' + f + '"' + (f === frecDefecto ? " selected" : "") + ">Cada " + f + " días</option>";
    }).join("");

    raiz.innerHTML =
      "<h3>" + (raiz.dataset.titulo || "Simula tu suscripción") + "</h3>" +
      '<div class="simulador__campo"><label for="sim-producto">Producto</label>' +
      '<select id="sim-producto">' + opcionesProducto + "</select></div>" +
      '<div class="simulador__campo"><label for="sim-pack">Cantidad por entrega</label>' +
      '<select id="sim-pack"></select></div>' +
      '<div class="simulador__campo"><label for="sim-frecuencia">Frecuencia de entrega</label>' +
      '<select id="sim-frecuencia">' + opcionesFrecuencia + "</select></div>" +
      '<div class="simulador__resultados" id="sim-resultados" aria-live="polite"></div>';

    var selProducto = document.getElementById("sim-producto");
    var selPack = document.getElementById("sim-pack");
    var selFrecuencia = document.getElementById("sim-frecuencia");

    function pintarPacks() {
      var p = productos[Number(selProducto.value)];
      var destacadaIdx = 0;
      selPack.innerHTML = p.variantes.map(function (v, i) {
        var b = bolsasDe(v.titulo);
        if (b === 3) destacadaIdx = i;
        return '<option value="' + i + '">' + b + (b === 1 ? " bolsa" : " bolsas") + " (" + b * caps + " cápsulas)</option>";
      }).join("");
      selPack.value = destacadaIdx;
    }

    function fila(etiqueta, valor, clase) {
      return '<div class="simulador__fila' + (clase ? " " + clase : "") + '"><span>' + etiqueta +
        '</span><span class="dato">' + valor + "</span></div>";
    }

    function calcular() {
      var p = productos[Number(selProducto.value)];
      var v = p.variantes[Number(selPack.value)] || p.variantes[0];
      var frecuencia = parseInt(selFrecuencia.value, 10) || frecDefecto;

      var unico = v.precio;
      var sub = Math.round(unico * (100 - dPermanente) / 100);
      var primera = Math.round(unico * (100 - dPrimera) / 100);
      var ahorroEntrega = unico - sub;
      var entregasPorMes = 30 / frecuencia;
      var ahorroMensual = ahorroEntrega * entregasPorMes;
      var ahorroAnual = ahorroMensual * 12;

      document.getElementById("sim-resultados").innerHTML =
        fila("Precio compra única", clp(unico) + " por entrega", "simulador__fila--tachado") +
        fila("Precio con NEAT Siempre", clp(sub) + " por entrega") +
        fila("Tu primera entrega (−" + dPrimera + "%)", clp(primera)) +
        fila("Ahorro mensual estimado", clp(ahorroMensual)) +
        fila("Ahorro anual estimado", clp(ahorroAnual), "simulador__fila--destacada") +
        '<p style="font-size:.78rem;color:var(--gris-suave);margin:.4rem 0 0">' + (raiz.dataset.nota || "") + "</p>";
    }

    selProducto.addEventListener("change", function () { pintarPacks(); calcular(); });
    selPack.addEventListener("change", calcular);
    selFrecuencia.addEventListener("change", calcular);

    pintarPacks();
    calcular();
  }

  /* =================== Año en el pie =================== */
  function iniciarAnio() {
    document.querySelectorAll("[data-anio]").forEach(function (el) {
      el.textContent = new Date().getFullYear();
    });
  }

  function iniciar() {
    iniciarAnuncios();
    iniciarHeader();
    iniciarMenuMovil();
    iniciarRevelado();
    iniciarBarras();
    iniciarSelectorPacks();
    iniciarProducto();
    iniciarSimulador();
    iniciarCalculadora();
    iniciarAnio();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", iniciar);
  } else {
    iniciar();
  }
})();
